/* Reach Forged — shared WhatsApp inquiry randomiser.
 *
 * The four numbers are NOT stored here. They live in the single source of
 * truth: snippets/reach-whatsapp.liquid, which boots this file by setting
 * window.reachWhatsApp.numbers (a Liquid-rendered array).
 *
 * Any anchor whose href carries the marker "#reach-whatsapp" is an inquiry
 * call-to-action. The footer's four contact links do not carry the marker, so
 * a buyer can still choose a specific number.
 *
 * Distribution: a shuffle bag, not a fresh Math.random() draw. Every four new
 * visitors get each number exactly once, which is what "roughly even" needs;
 * independent random draws cluster (a number can miss ten visitors in a row).
 *
 * Stability: the pick is held for the session, so one visitor keeps the same
 * contact across pages instead of meeting a different name on every page.
 *
 * The query string is preserved. The previous version replaced the whole href,
 * which silently dropped the prefilled message on the quote module.
 */
(function () {
  'use strict';

  var MARKER = '#reach-whatsapp';
  var PICK_KEY = 'rf_wa_pick';
  var BAG_KEY = 'rf_wa_bag';

  function getNumbers() {
    var config = window.reachWhatsApp || {};
    return Array.isArray(config.numbers) ? config.numbers.filter(Boolean) : [];
  }

  function shuffled(list) {
    var out = list.slice();
    for (var i = out.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = out[i];
      out[i] = out[j];
      out[j] = swap;
    }
    return out;
  }

  function nextNumber(list) {
    try {
      var saved = sessionStorage.getItem(PICK_KEY);
      if (saved && list.indexOf(saved) > -1) return saved;
    } catch (e) {}

    var bag = [];
    try {
      bag = JSON.parse(localStorage.getItem(BAG_KEY) || '[]');
    } catch (e) {
      bag = [];
    }
    bag = bag.filter(function (n) { return list.indexOf(n) > -1; });
    if (!bag.length) bag = shuffled(list);

    var chosen = bag.shift();
    try { localStorage.setItem(BAG_KEY, JSON.stringify(bag)); } catch (e) {}
    try { sessionStorage.setItem(PICK_KEY, chosen); } catch (e) {}
    return chosen;
  }

  function randomise() {
    var list = getNumbers();
    if (!list.length) return;

    var anchors = document.querySelectorAll('a[href*="' + MARKER + '"]');
    if (!anchors.length) return;

    var chosen = null;
    for (var i = 0; i < anchors.length; i++) {
      var href = anchors[i].getAttribute('href') || '';
      var match = href.match(/wa\.me\/(\d+)/);
      var bare = /^#reach-whatsapp$/.test(href.trim());
      if (!match && !bare) continue;

      if (chosen === null) chosen = nextNumber(list);
      anchors[i].setAttribute(
        'href',
        match ? href.replace(match[1], chosen) : 'https://wa.me/' + chosen + MARKER
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', randomise);
  } else {
    randomise();
  }
  document.addEventListener('shopify:section:load', randomise);
})();
